import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { AuthLayout } from '../../components/layouts/AuthLayout';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { ArrowLeft } from 'lucide-react';
export function LoginPage() {
  const navigate = useNavigate();
  const [step, setStep] = useState<'mobile' | 'otp'>('mobile');
  const [mobile, setMobile] = useState('');
  const [otp, setOtp] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const handleSendOtp = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Mock API call
    setTimeout(() => {
      setIsLoading(false);
      setStep('otp');
    }, 1000);
  };
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Mock API call
    setTimeout(() => {
      setIsLoading(false);
      navigate('/dashboard');
    }, 1000);
  };
  return <AuthLayout title="ورود به سامانه" subtitle="برای ورود شماره موبایل خود را وارد کنید" data-id="element-526">
      {step === 'mobile' ? <form onSubmit={handleSendOtp} className="space-y-6" data-id="element-527">
          <Input label="شماره موبایل" placeholder="09123456789" value={mobile} onChange={e => setMobile(e.target.value)} required type="tel" dir="ltr" className="text-left" data-id="element-528" />
          <Button type="submit" className="w-full" isLoading={isLoading} data-id="element-529">
            دریافت کد تایید
          </Button>
          <div className="text-center text-sm" data-id="element-530">
            حساب کاربری ندارید؟{' '}
            <Link to="/register" className="text-primary hover:underline font-medium" data-id="element-531">
              ثبت نام کنید
            </Link>
          </div>
        </form> : <form onSubmit={handleLogin} className="space-y-6" data-id="element-532">
          <div className="text-center mb-4" data-id="element-533">
            <p className="text-sm text-gray-600" data-id="element-534">
              کد تایید به شماره {mobile} ارسال شد
            </p>
            <button type="button" onClick={() => setStep('mobile')} className="text-xs text-primary mt-1 hover:underline" data-id="element-535">
              ویرایش شماره
            </button>
          </div>
          <Input label="کد تایید" placeholder="12345" value={otp} onChange={e => setOtp(e.target.value)} required type="text" className="text-center tracking-widest text-lg" maxLength={5} data-id="element-536" />
          <Button type="submit" className="w-full" isLoading={isLoading} data-id="element-537">
            ورود به حساب
          </Button>

          <div className="flex justify-center" data-id="element-538">
            <Button variant="ghost" size="sm" onClick={() => setStep('mobile')} className="text-gray-500" data-id="element-539">
              <ArrowLeft className="h-4 w-4 ml-1" data-id="element-540" />
              بازگشت
            </Button>
          </div>
        </form>}
    </AuthLayout>;
}